<template>
  <div class="promotion">
    <section
      v-if="promotion.PromotionDataList && promotion.PromotionDataList.length > 0"
    >
      <div
        v-for="singlePromotion in promotion.PromotionDataList"
        :key="singlePromotion.PromotionId"
        class="promotion-list"
        @click="promotionToShow = singlePromotion; isShowPromotionModal = true"
      >
        <div
          v-if="!isMobile"
          class="promotion-list__item"
          :class="{ 'promotion-list__item--half': itemHalf }"
        >
          <div class="promotion-list__item-wrap">
            <div class="promotion-list__label">
              多件優惠
            </div>
            <span class="promotion-list__text">{{ singlePromotion.PromotionName }}</span>
          </div>
          <i class="promotion-list__arrow icon icon-chevron-right1" />
        </div>
        <div
          v-else
          class="mobile-promotion__item">
          <div class="mobile-promotion__label">
            多件
          </div>
          <div class="mobile-promotion__text">
            <span>最高折</span><span>${{ singlePromotion.maxDiscount }}</span>
          </div>
        </div>
      </div>
    </section>
    <bottom-up-modal
      id="modal-promotion"
      :prop-show="isShowPromotionModal"
      prop-title="活動詳情"
      @close="isShowPromotionModal = false"
    >
      <template
        v-if="promotionToShow"
        #content
      >
        <div class="modal-promotion">
          <div class="modal-promotion__title mb-2">
            <span class="promotion-label mr-2">多件優惠</span>
            <span class="fs-17 fw-600">{{ promotionToShow.PromotionName }}</span>
          </div>
          <div class="modal-promotion__desc fs-17 mb-3">
            {{ promotionToShow.PromotionDescription }}
          </div>
          <div class="modal-promotion__duration fs-15 dark-gray-color mb-6">
            活動期間：{{ $dayjs(promotionToShow.StartTimeStr).format('YYYY/MM/DD HH:mm') }}~{{ $dayjs(promotionToShow.EndTimeStr).format('YYYY/MM/DD HH:mm') }}
          </div>
          <div class="modal-promotion__detail-list">
            <div
              v-for="detail in promotionToShow.DetailList"
              :key="detail.Id"
              class="modal-promotion__detail-item"
            >
              <div class="promotion-tag fs-16 fw-600 mr-2">
                滿{{ setPriceFormat(detail.Quantity) }}件
              </div>
              <div class="fs-15">
                每件折{{ setPriceFormat(detail.DiscountAmount) }}元
              </div>
            </div>
          </div>
        </div>
      </template>
    </bottom-up-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import BottomUpModal from '../Modal/BottomUpModal.vue'
export default {
  components: {
    BottomUpModal
  },
  props: {
    itemHalf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowPromotionModal: false,
      promotionToShow: null
    }
  },
  computed: {
    ...mapState('purchaseStore', ['promotion']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    setPriceFormat (price) {
      if (price === null || price === undefined) return null
      return price?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  }
}
</script>
<style lang="scss" scoped>

.promotion-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  gap: 11px;
  &__item {
    width: calc(100% / 3);
    min-width: fit-content;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 14px 8px 12px;
    background-color: #FFEFDD;
    cursor: pointer;
    border-radius: 6px;
    &--half {
      width: calc(50% - 5.5px);
    }
  }
  &__item-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__label {
    background-color: $orangeColor;
    color: $whiteColor;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 2px;
  }
  &__text {
    color: $orangeColor;
    font-weight: 600;
  }
  &__arrow {
    font-size: 14px;
    color: $orangeColor;
  }
}

.mobile-promotion {
  &__item {
    font-size: 14px;
    font-weight: bold;
    padding: 8px 12px;
    display: inline-flex;
    align-items: center;
    position: relative;
    background-color: #ffefdd;
    border-radius: 6px;
    &::before, &::after {
      content: "";
      width: 12px;
      height: 12px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: $whiteColor;
    }
    &::before {
      left: -6px;
    }
    &::after {
      right: -6px;
    }
  }
  &__label {
    padding: 2px 4px;
    margin-right: 6px;
    border-radius: 2px;
    color: $whiteColor;
    background-color: $orangeColor;
  }
  &__text {
    color: $orangeColor;
  }
}

.modal-promotion {
  padding: 24.5px 40px 40px;

  &__detail-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
  }
  &__detail-item {
    display: flex;
    align-items: center;
  }
}

.promotion-label {
  display: inline-block;
  color: $whiteColor;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: $orangeColor;
  font-size: pxTorem(13px);
  font-weight: 600;
}

.promotion-tag {
  padding: 2px 15px;
  color: $whiteColor;
  background-color: $mainColor;
  white-space: nowrap;
}

@media screen and (max-width: $mobileWidth) {
  .modal-promotion {
    padding: 24.5px 19px 54px;
  }

  .promotion-list {
    gap: 8px;
  }

  .mobile-promotion {
    &__item {
      overflow: hidden;
    }
  }
}
</style>
